import { useQuery } from "@tanstack/react-query";
import { useAtomValue } from "jotai";
import { queriesEnabledAtom } from "../../../atoms/GlobalAtoms";
import { FeedbackConversationCard } from "../../../components/BrieChatMenu/BrieChatFeedback";
import API from "../../api/API";

interface UseFeedbackMessages {
  conversations: FeedbackConversationCard[];
  conversationsLoading: boolean;
}

const defaultMessages: [] = [];

const useFeedbackConversations = () => {
  const queriesEnabled = useAtomValue(queriesEnabledAtom);

  const conversations = useQuery({
    queryKey: ["feedbackMessages"],
    queryFn: () =>
      API.getFeedbackConversations().then((data) => data.data.data.messages),
    enabled: queriesEnabled,
  });

  const result: UseFeedbackMessages = {
    conversations: conversations.data || defaultMessages,
    conversationsLoading: conversations.isLoading || queriesEnabled === false,
  };

  return result;
};

export default useFeedbackConversations;
